const arrayIsSame = (array1, array2) => {
  let cArray1 = [...new Set(array1)];
  let cArray2 = [...new Set(array2)];

  return JSON.stringify(cArray1.sort()) === JSON.stringify(cArray2.sort());
};

const objectValues = object => {
  return Object.keys(object).map(key => {
    return object[key];
  });
};

const getKeyByValue = (object, value) => {
  for (const key of Object.keys(object)) {
    if (object[key] === value) {
      return key;
    }
  }
};

export { arrayIsSame, getKeyByValue, objectValues };
